import React from "react";
import { Box, Typography, Avatar, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

import { getRuta, simpleMessage } from "../helpers/Helpers";
import { apiLogOut, getRol, getUser } from "../api/Account";
import { sidebar } from "../theme";

// Bloque de usuario en el pie del sidebar — ver README.md (Shell).
// Sustituye al menú desplegable que antes vivía en el topbar (NavBarElements):
// click en el perfil -> Mi cuenta, icono de logout -> cerrar sesión (mismo flujo de antes).
const SidebarFooter = ({ setIsLogged, setIsDarkMode }) => {
  const navigate = useNavigate();
  const user = getUser();
  const rol = getRol();
  const rout = getRuta();

  const initials = user
    ? `${user.split(" ")[0][0] || ""}${(user.split(" ")[1] || "")[0] || ""}`
    : "";

  const goToAccount = () => {
    navigate(`${rout}/account`);
  };

  const logOut = () => {
    const result = apiLogOut();
    if (!result.statusResponse) {
      simpleMessage("No se pudo cerrar sesion, intente de nuevo", "error");
    }
    setIsDarkMode(false);
    setIsLogged(false);
    navigate(rout);
  };

  return (
    <Box
      sx={{
        padding: "14px 16px",
        borderTop: `1px solid ${sidebar.footerBorder}`,
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <Box
        onClick={goToAccount}
        sx={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: 0, cursor: "pointer" }}
      >
        <Avatar sx={{ width: 32, height: 32, bgcolor: "#00a152", fontWeight: 600, fontSize: 12.5, flexShrink: 0 }}>
          {initials}
        </Avatar>
        <Box sx={{ lineHeight: 1.2, minWidth: 0 }}>
          <Typography
            sx={{
              color: "#e8edf3",
              fontSize: 12.5,
              fontWeight: 600,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {user || ""}
          </Typography>
          <Typography sx={{ color: "#66788f", fontSize: 11 }}>{rol || ""}</Typography>
        </Box>
      </Box>
      <IconButton
        onClick={logOut}
        title="Cerrar sesión"
        sx={{ color: "#66788f", "&:hover": { color: "#ff8585" } }}
      >
        <LogoutRoundedIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
};

export default SidebarFooter;
